import ProjectGroupLayout from "./ProjectGroupLayout";
export default ProjectGroupLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/ProjectGroupLayout/index.tsx